import * as olProj from './../node_modules/ol/proj.js';
import {applyTransform} from './../node_modules/ol/extent.js';

function transformExtent (extent, source, destination, stops) {
    var modifiedExtent = extent;
    try {
        modifiedExtent = modifiedExtent.map((coord)=>{
            return parseFloat(coord);
        });
    } catch (e) {

    }
    const transformFunc = olProj.getTransform(source, destination);
    return applyTransform(modifiedExtent, transformFunc, undefined, stops);
}

export default {
    ...olProj,
    transformExtent
};